import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportingService } from '../../reporting-service.service';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import {  ReportMainData } from 'app/ReportingModel/ReportFiltering';
@Component({
    selector: 'app-booked-time-by-engagement-report',
    templateUrl: './booked-time-by-engagement-report-component.html',
    styleUrls: ['./booked-time-by-engagement-report-component.scss']
})
export class BookedTimeByEngagementReportComponent implements OnInit {
    @Input() ReportMainData: ReportMainData;
    constructor(private spinner: NgxSpinnerService, private reportService: ReportingService) { }
    ngOnInit(): void {
        this.spinner.show();
        this.spinner.hide();
       
    }
}